import { useRef, useEffect, useState } from "react";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../utils/configurationProvider";
import "./index.css";

const TickerAnimation = ({ text, fontSize }) => {
  const containerRef = useRef(null);
  const textRef = useRef(null);

  const [isOverflowing, setIsOverflowing] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [initialRun, setInitialRun] = useState(false);

  useEffect(() => {
    const container = containerRef?.current;
    const content = textRef?.current;
    if (!container || !content) return;

    const checkOverflow = () => {
      const isOverflow = content?.scrollWidth > container?.clientWidth;
      setIsOverflowing(isOverflow);
    };

    const observer = new ResizeObserver(() => {
      checkOverflow();
    });

    observer?.observe(container);
    observer?.observe(content);

    requestAnimationFrame(() => {
      requestAnimationFrame(checkOverflow);
    });

    return () => observer?.disconnect();
  }, [text]);

  useEffect(() => {
    if (!isOverflowing) {
      setInitialRun(false);
      return;
    }

    setInitialRun(true);

    const timer = setTimeout(() => {
      setInitialRun(false);
    }, IntervalConfiguration?.intervalTicker);

    return () => clearTimeout(timer);
  }, [isOverflowing, text]);

  useEffect(() => {
    if (!isOverflowing) return;

    const content = textRef?.current;
    if (!content) return;

    const distance = content?.scrollWidth;
    const speed = IntervalConfiguration?.intervalSpeedTicker;

    const duration = Math.max(
      distance / speed,
      GlobalConfiguration?.lengthCheckOne,
    );

    content?.style?.setProperty("--scroll-time", `${duration}s`);
  }, [isOverflowing, text]);

  const shouldAnimate = isOverflowing && (isHovered || initialRun);

  return (
    <div
      className="ticker-wrapper flex items-center w-width-full"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        ref={containerRef}
        className="overflow-hidden min-w-0 w-width-full"
      >
        <p
          ref={textRef}
          className={`ticker-text m-margin_base text-${fontSize} ${
            shouldAnimate ? "ticker-animate" : "animate-none translate-x-0"
          }`}
        >
          {text}
        </p>
      </div>
    </div>
  );
};

export default TickerAnimation;
